import api from "@/lib/axios";
import { API_URL } from "@/config";

export const getRecruiterPdfViewUrl = (recruiter) => {
  if (!recruiter?.id) return null;
  if (recruiter.pdf_view_url) return recruiter.pdf_view_url;
  if (
    recruiter.has_pdf ||
    recruiter.pdf_url ||
    recruiter.pdf ||
    recruiter.document_url ||
    recruiter.document
  ) {
    return `${API_URL}/recruiters/${recruiter.id}/pdf/view`;
  }
  return null;
};

export const recruitersService = {  // Get all recruiters
  getAllRecruiters: async () => {
    try {
      const { data } = await api.get("/recruiters");
      return data.data; // Access the nested data array
    } catch (error) {
      throw new Error("Failed to fetch recruiters: " + error.message);
    }
  },

  // recruiter companies
  getRecruiterCompanies: async () => {
    try {
      const { data } = await api.get("/recruiter-companies");
      return data.data;
    } catch (error) {
      throw new Error("Failed to fetch recruiter companies: " + error.message);
    }
  },



// get company of recruiter
  getCompanyOfRecruiter: async (params) => {
    try {
      const response = await api.get("/user/companies", {
        params: params
      });
      return response.data;
    } catch (error) {
      throw new Error("Failed to fetch company of recruiter: " + error.message);
    }
  },

  uploadRecruiterPdf: async (recruiterId, file) => {
    try {
      const formData = new FormData();
      formData.append("pdf", file);
      const { data } = await api.post(`/recruiters/${recruiterId}/pdf`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to upload PDF";
      throw new Error(message);
    }
  },

};


